export default function appointmentWasCreated(appointment) {
  if (!appointment) {
    return false;
  }

  // Logged-out create always returns empty attributes (HidePhi), including the
  // duplicate-email case where no appointment is saved. Only a payload with
  // booking attrs (logged-in persist) means a real appointment was created.
  return Boolean(appointment.confirmationStatus || appointment.startTime);
}
